import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_INPUT_LIST_SCHEMA = Object.freeze({
  INPUT_TYPE: '',
});
const RECORD = generateSchema(TRACKING_INPUT_LIST_SCHEMA);
const KEYS: any = generateKeys(TRACKING_INPUT_LIST_SCHEMA);

export class InputListTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.input_list;
  }

  get properties() {
    return this.toJS();
  }
}
